import {clsx, type ClassValue} from "clsx"
import {twMerge} from "tailwind-merge"
import {v4 as uuidv4} from "uuid";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function generateChannelCode(): string {
    const timestamp = Date.now() // 毫秒时间戳，10 位或 13 位
    // 转为 36 进制字符串，并大写
    return timestamp.toString(36).toUpperCase()
}

export function range(n: number): number[] {
    return Array.from({length: n + 1}, (_, i) => i)
}

export function generateUniqueId() {
    return uuidv4().replace(/-/g, '').toLowerCase();
}
